
export default {
  resetSearch () {
    this.$refs.searchForm.resetFields();
    this.searchForm.page = 1
    this.searchForm.list_rows = 30
    this.pagination.current = 1
    this.pagination.pageSize = 30
  }
} 